import type React from "react";
import { config } from "../config";

interface HeaderProps {
	hasActiveSession: boolean;
	userEmail?: string;
	onAccountClick: () => void;
	onSignInClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({
	hasActiveSession,
	userEmail,
	onAccountClick,
	onSignInClick,
}) => {
	return (
		<header
			style={{
				backgroundColor: "#fff",
				borderBottom: "1px solid #e0e0e0",
				padding: "1rem 2rem",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
			}}
		>
			<a href={`https://${config.cmsBaseUrl}`}>
				<img
					src="/static_assets/logo_dark_text.png"
					alt="GiveWise"
					style={{
						height: "36px",
						display: "block",
					}}
				/>
			</a>

			{hasActiveSession ? (
				<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
					{userEmail && <span className="header-email">{userEmail}</span>}
					<button
						type="button"
						onClick={onAccountClick}
						className="secondary-button"
					>
						Account
					</button>
				</div>
			) : (
				<button
					type="button"
					onClick={onSignInClick}
					className="secondary-button"
				>
					Sign In
				</button>
			)}
		</header>
	);
};
